import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    fontFamily: 'Roboto',
    '@media all and (max-width: 900px)': {
      height: '100vh',
      marginTop: 80
    }
  },
  boxtitle: {
    width: '90%',
    display: 'flex',
    color: '#4B4952',
    marginLeft: '5%',
    marginTop: '1.5rem'
  },
  title: {
    fontSize: '2em',
    letterSpacing: '0.04rem',
    '@media all and (max-width: 600px)': {
      fontSize: '1.5em'
    }
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row'
  },
  confirmButton: {
    height: 28,
    width: 130,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 20,
    marginTop: 8,
    cursor: 'pointer',
    background: '#f9f9f9',

    '&:hover': {
      backgroundColor: '#f2f2f2'
    },
    border: '2px solid #263057',
    borderRadius: '23px'
  },
  confirmButtonTypography: {
    fontFamily: 'Raleway',
    fontSize: '0.9em',
    letterSpacing: '0.05em',
    color: '#028B7E'
  },
  boxSubTitle: {
    width: '90%',

    color: '#2C3532',
    marginLeft: '5%',
    marginTop: '0.5rem',
    paddingLeft: '0.2rem',
    '@media all and (max-width: 600px)': {
      fontSize: '0.8em'
    }
  },
  boxTable: {
    width: '95%',
    marginTop: '1rem',
    marginLeft: '5%'
  },
  boxButtonAdd: {
    marginTop: '1.2rem',
    marginLeft: '5.5%',
    display: 'flex'
  },
  boxDetails: {
    width: '80%',
    marginLeft: '5%',
    marginTop: '2%',
    paddingBottom: 5,
    paddingTop: 5,
    background: '#f9f9f9',
    boxShadow: '0px 1px 4px rgba(36, 55, 143, 0.2)',
    borderRadius: 10,
    marginBottom: 10,
    '@media all and (max-width: 900px)': {
      marginBottom: 100
    }
  }
}))

export default useStyles
